module.exports = __webpack_public_path__ + "img/25-Digestion.5cd18c87.png";